<template>
    <div class="ios-button-parent">
        <div v-bind:class="{'on' : is_active}"
             v-on:click="toggleIos"
             v-bind:disabled="loading"
             class="ios-button"></div>
        <label class="ios-text" v-html='text'></label>
    </div>
</template>

<script>
    export default {
        props: [
            'text', 'is_active', 'url', 'send_value', 'hidden_element_name'
        ],
        data: function () {
            return {
                loading: false,
                valuesToServer: this.send_value ? {value: this.send_value} : {}
            }
        },
        methods: {
            toggleIos: function () {
                if (this.hidden_element_name === undefined) {
                    const thisVm = this;
                    if (this.loading === false) {
                        axios.post(this.url, this.valuesToServer)
                        .then(function (response) {
                            thisVm.is_active = response.data;
                            thisVm.loading   = false;
                        })
                        .catch(function (error) {
                            thisVm.loading = false;
                        })
                    }
                } else {
                    this.is_active = !this.is_active;
                    $("[name=" + this.hidden_element_name + "]").val(this.is_active === true ? '1' : '0').trigger('change');
                }
            }
        }
    }
</script>
